export const TAGS = [
    "处女作", "悬赏塔", "高难塔", "剧情向", "加点塔", "转换塔", "道具塔", "境界塔", "技能塔", "平面塔", "连载塔", "机关塔", "小游戏"
];

export const COLORS = [
    { name: '白', value: 'rgba(252,252,252,0.6)' },
    { name: '橙', value: '#FFC088' },
    { name: '蓝', value: 'lightblue' },
    { name: '绿', value: 'lightgreen' },
    { name: '红', value: '#FF9999' },
    { name: '紫', value: '#ded0ff' },
]